import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isNotNil } from '@flowio/is';
import { Callbacks } from '@flowio/callbacks';

var TaskQueue = /*#__PURE__*/function () {
  function TaskQueue() {
    _classCallCheck(this, TaskQueue);

    _defineProperty(this, "callbacks", void 0);

    _defineProperty(this, "parameters", void 0);

    _defineProperty(this, "tokens", void 0);

    _defineProperty(this, "isRunning", void 0);

    this.parameters = null;
    this.callbacks = new Callbacks();
    this.tokens = [];
    this.isRunning = false;
  }

  _createClass(TaskQueue, [{
    key: "dequeue",
    value: function dequeue() {
      var callbacks = this.callbacks,
          parameters = this.parameters;
      var tokens = this.tokens.splice(0);

      var recurse = function recurse() {
        var token = tokens.shift();

        if (isNotNil(token) && isNotNil(parameters)) {
          callbacks.invoke.apply(callbacks, [token].concat(_toConsumableArray(parameters)));
          callbacks.remove(token);
        }

        if (tokens.length) {
          setTimeout(recurse, 0);
        }
      };

      recurse();
    }
  }, {
    key: "enqueue",
    value: function enqueue(task) {
      var token = this.callbacks.add(task);
      this.tokens.push(token);
      return token;
    }
  }, {
    key: "flush",
    value: function flush() {
      if (this.isRunning && this.tokens.length) {
        this.dequeue();
      }
    }
  }, {
    key: "insert",
    value: function insert(task) {
      var token = this.enqueue(task);
      this.flush();
      return token;
    }
  }, {
    key: "remove",
    value: function remove(token) {
      var index = this.tokens.indexOf(token);

      if (index > -1) {
        this.tokens.splice(index, 1);
      }
    }
    /** @deprecated */

  }, {
    key: "ready",
    value: function ready() {
      this.run.apply(this, arguments);
    }
  }, {
    key: "run",
    value: function run() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.parameters = args;
      this.isRunning = true;
      this.flush();
    }
  }, {
    key: "pause",
    value: function pause() {
      this.isRunning = false;
    }
  }]);

  return TaskQueue;
}();

export default TaskQueue;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/task-queue/lib/esm/TaskQueue.js
// module id = 698
// module chunks = 0 1